module.exports = __webpack_public_path__ + "img/7.e20897b7.svg";